export interface DirectBomRow {
  finished_good_sku: string;
  template_id: number | null;
  revision: string | number | null;
  variable_name: string | null;
  component_sku: string;
}

/** The finished good listed as its own component, which process_boms adds when include_self is true. */
export function isBomFinishedGoodSelfRow(row: DirectBomRow, finishedGoodSku: string): boolean {
  return (
    row.component_sku.trim() === finishedGoodSku.trim() &&
    row.variable_name == null &&
    row.template_id == null &&
    row.revision == null
  );
}

/** Rows that belong on this SKU's own bill, not on a nested subassembly. */
export function directBomRows<T extends DirectBomRow>(rows: readonly T[], finishedGoodSku: string): T[] {
  const parent = finishedGoodSku.trim();
  return rows.filter(
    (row) => row.finished_good_sku.trim() === parent && !isBomFinishedGoodSelfRow(row, parent),
  );
}
